(function(){
  if(window.__upkQVInit) return; window.__upkQVInit=1;

  var ov=document.createElement('div'); ov.className='upk-qv-ov';
  var dr=document.createElement('div'); dr.className='upk-qv'; dr.setAttribute('role','dialog'); dr.setAttribute('aria-modal','true'); dr.setAttribute('aria-label','Quick view');
  dr.innerHTML='<div class="upk-qv-head"><b>Quick view</b><button type="button" class="upk-qv-x" aria-label="Close">&times;</button></div><div class="upk-qv-body"></div><div class="upk-qv-foot"><a class="upk-qv-view" href="#">View full details &rsaquo;</a></div>';
  document.body.appendChild(ov); document.body.appendChild(dr);
  var body=dr.querySelector('.upk-qv-body');
  var viewLink=dr.querySelector('.upk-qv-view');
  function open(){dr.classList.add('open');ov.classList.add('open');document.documentElement.style.overflow='hidden';}
  function close(){dr.classList.remove('open');ov.classList.remove('open');document.documentElement.style.overflow='';}
  ov.addEventListener('click',close);
  dr.querySelector('.upk-qv-x').addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!(window.upkLightbox&&window.upkLightbox.isOpen()))close();});

  function execInjectedScripts(scope){
    /* P12.3a: the product page's lazily loaded helper scripts (data-upk-lazy-src, see sections/upk-pdp) load at once
       inside the quick view, which is itself an interaction. */
    scope.querySelectorAll('script[data-upk-lazy-src]').forEach(function(s){
      if(s.hasAttribute('data-upk-inert')) return;
      s.setAttribute('data-upk-inert','1');
      var lsrc=s.getAttribute('data-upk-lazy-src'); if(!lsrc) return;
      if(document.querySelector('script[src="'+lsrc+'"]')) return;
      var ln=document.createElement('script'); ln.src=lsrc; ln.defer=true; ln.setAttribute('data-upk-exec','1');
      document.head.appendChild(ln);
    });
    scope.querySelectorAll('script[src]').forEach(function(s){
      if(s.hasAttribute('data-upk-inert')) return;
      s.setAttribute('data-upk-inert','1');
      var src=s.getAttribute('src'); if(!src) return;
      var existing=document.querySelectorAll('script[src="'+src+'"]');
      for(var i=0;i<existing.length;i++){ if(!existing[i].hasAttribute('data-upk-inert')) return; }
      var n=document.createElement('script'); n.src=src; n.defer=true; n.setAttribute('data-upk-exec','1');
      document.head.appendChild(n);
    });
  }

  function stripBelowShipping(scope){
    var pdp=scope.querySelector('.upk-pdp'); if(!pdp) return;
    var wrap=pdp.querySelector('.upk-pdp-wrap'); if(!wrap) return;
    var n=wrap.nextElementSibling;
    while(n){ var rm=n; n=n.nextElementSibling; rm.remove(); }
  }

  function reorderTopSection(scope){
    var wrap=scope.querySelector('.upk-pdp-wrap'); if(!wrap) return;
    var info=wrap.querySelector('.upk-info'); if(!info) return;

    var stockEl=info.querySelector('.upk-stock');
    if(stockEl){
      var anchor1=stockEl;
      info.querySelectorAll('.upk-opt').forEach(function(opt){
        anchor1.insertAdjacentElement('afterend', opt);
        anchor1=opt;
      });
    }

    var taxEl=info.querySelector('.upk-tax');
    var ctaEl=info.querySelector('.upk-cta');
    if(taxEl && ctaEl){ taxEl.insertAdjacentElement('afterend', ctaEl); }

    var offersEl=info.querySelector('.upk-offers') || info.querySelector('.upk-mat');
    if(offersEl){
      var anchor2=offersEl;
      var giftboxEl=info.querySelector('.upk-giftbox');
      var initboxEl=info.querySelector('.upk-initbox');
      if(giftboxEl){ anchor2.insertAdjacentElement('afterend', giftboxEl); anchor2=giftboxEl; }
      if(initboxEl){ anchor2.insertAdjacentElement('afterend', initboxEl); anchor2=initboxEl; }
    }
  }

  /* The Pair It Up strip is a native overflow-x:auto scroller with no
     built-in drag/arrow support of its own, it relies on the browser's
     scrollbar or touch/trackpad swipe. We hide that scrollbar for a
     cleaner look inside the drawer, so we need to supply our own ways to
     scroll it: click-and-drag with a mouse, vertical-wheel-to-horizontal
     while hovering it, and simple prev/next arrow buttons. Cards are
     appended asynchronously by upk-pair-it-up.js, but all of this only
     needs the container element itself, so it's safe to wire up right
     after the PDP markup lands, before those cards have loaded in. */
  function enhancePiuScroll(scope){
    var wrap=scope.querySelector('.upk-piu'); if(!wrap) return;
    var strip=wrap.querySelector('.upk-piu-strip'); if(!strip) return;
    if(strip.hasAttribute('data-upk-enhanced')) return;
    strip.setAttribute('data-upk-enhanced','1');

    var prev=document.createElement('button');
    prev.type='button'; prev.className='upk-qv-piu-arrow upk-qv-piu-arrow--prev'; prev.setAttribute('aria-label','Scroll left'); prev.innerHTML='&#8249;';
    var next=document.createElement('button');
    next.type='button'; next.className='upk-qv-piu-arrow upk-qv-piu-arrow--next'; next.setAttribute('aria-label','Scroll right'); next.innerHTML='&#8250;';
    wrap.style.position='relative';
    wrap.appendChild(prev); wrap.appendChild(next);

    function step(){ return Math.round(strip.clientWidth*0.7) || 200; }
    prev.addEventListener('click', function(){ strip.scrollBy({left:-step(), behavior:'smooth'}); });
    next.addEventListener('click', function(){ strip.scrollBy({left:step(), behavior:'smooth'}); });

    /* mouse click-and-drag */
    var dragging=false, startX=0, startScroll=0, moved=false;
    strip.addEventListener('pointerdown', function(e){
      if(e.pointerType==='touch') return; /* native touch scroll already works */
      dragging=true; moved=false; startX=e.clientX; startScroll=strip.scrollLeft;
      try{ strip.setPointerCapture(e.pointerId); }catch(err){}
    });
    strip.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>3) moved=true;
      strip.scrollLeft=startScroll-dx;
    });
    function endDrag(e){
      if(!dragging) return;
      dragging=false; strip.style.cursor='grab';
      /* release pointer capture explicitly, an uncaptured pointer can, in
         some browsers, keep swallowing subsequent pointer/click events on
         the rest of the page if capture is left dangling past pointerup. */
      try{ if(e && e.pointerId!=null) strip.releasePointerCapture(e.pointerId); }catch(err){}
    }
    strip.addEventListener('pointerup', endDrag);
    strip.addEventListener('pointercancel', endDrag);
    strip.addEventListener('lostpointercapture', function(){ dragging=false; strip.style.cursor='grab'; });
    /* prevent the drag turning into an accidental card click */
    strip.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);

    /* vertical wheel -> horizontal scroll while hovering the strip */
    strip.addEventListener('wheel', function(e){
      if(strip.scrollWidth<=strip.clientWidth) return;
      if(Math.abs(e.deltaY)<=Math.abs(e.deltaX)) return;
      strip.scrollLeft+=e.deltaY;
      e.preventDefault();
    }, {passive:false});

    strip.style.cursor='grab';
  }

  /* P4b.6: the quick view gallery (the thumbnail row is the slider) opens the shared lightbox (assets/upk-lightbox.js)
     with the product's photos at 1200 px: tap a thumbnail, then swipe or use the arrow keys between photos. The quick
     view stays open underneath and is exactly as it was when the lightbox closes. */
  function bigImage(u){ return String(u||'').replace(/([?&])width=\d+/,'$1width=1200'); }
  function wireLightbox(scope){
    var dataEl=scope.querySelector('[data-upk-images]'); var imgs=[];
    try{ imgs=JSON.parse(dataEl?dataEl.textContent:'[]')||[]; }catch(e){ imgs=[]; }
    var title=(scope.querySelector('.upk-name')||{}).textContent||'';
    title=String(title).trim();
    var thumbs=scope.querySelectorAll('[data-upk-thumb]');
    if(!thumbs.length){
      /* P12.1 (Cowork review 19 Oct, item 5): a product with one photo renders no thumbnail row on the PDP, and the quick
         view hides the main image because the thumbnail row is its gallery, so nothing showed. Build a one-thumb row from
         the main image (a 140 px copy), wired to the lightbox like any other thumb. */
      var main=scope.querySelector('.upk-gal-main img');
      var mainSrc=main?(main.getAttribute('src')||main.currentSrc||''):'';
      var gal=scope.querySelector('.upk-gal');
      if(!mainSrc||!gal) return;
      var row=document.createElement('div'); row.className='upk-thumbs upk-thumbs--single';
      var one=document.createElement('button'); one.type='button'; one.className='upk-thumb active'; one.setAttribute('data-upk-thumb','');
      var im=document.createElement('img'); im.src=String(mainSrc).replace(/([?&])width=\d+/,'$1width=140'); im.alt=''; im.width=68; im.height=68; im.decoding='async';
      one.appendChild(im); row.appendChild(one); gal.appendChild(row);
      one.setAttribute('data-upk-lightbox', bigImage(mainSrc));
      one.setAttribute('data-upk-lightbox-alt', title);
      one.setAttribute('aria-label','Image 1 of 1, tap to enlarge');
      return;
    }
    thumbs.forEach(function(t,k){
      var im=t.querySelector('img');
      var src=imgs[k]||(im?im.getAttribute('src'):'')||'';
      if(!src) return;
      t.setAttribute('data-upk-lightbox', bigImage(src));
      t.setAttribute('data-upk-lightbox-group','upk-qv-gallery');
      t.setAttribute('data-upk-lightbox-alt', title);
      t.setAttribute('aria-label','Image '+(k+1)+' of '+thumbs.length+', tap to enlarge');
    });
  }

  /* fetch() with a hard timeout, a hung/never-resolving request used to
     leave the drawer stuck on "Loading…" forever with the page's scroll
     locked (open() sets overflow:hidden), which reads as the whole page
     having frozen. AbortController guarantees this settles one way or
     the other within TIMEOUT_MS no matter what the network does. */
  var TIMEOUT_MS = 8000;
  function fetchWithTimeout(url, opts){
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, TIMEOUT_MS) : null;
    var merged = ctrl ? Object.assign({}, opts, {signal: ctrl.signal}) : opts;
    return fetch(url, merged).finally(function(){ if(timer) clearTimeout(timer); });
  }

  function openQuickView(url){
    if(!url)return; url=url.split('?')[0].split('#')[0];
    viewLink.href=url;
    body.innerHTML='<div class="upk-qv-loading">Loading\u2026</div>';
    body.scrollTop=0;
    open();

    var settled=false;
    /* Belt-and-braces watchdog: even if some future change makes a fetch
       promise neither resolve nor reject (e.g. a browser quirk with abort
       signals), this guarantees the drawer gives up and becomes usable
       again, the page must never stay stuck on "Loading…" indefinitely. */
    var watchdog=setTimeout(function(){ if(!settled) showFailed(); }, TIMEOUT_MS + 3000);

    function loadFromDoc(text){
      var doc=new DOMParser().parseFromString(text,'text/html');
      return doc.querySelector('.upk-pdp');
    }
    function render(sec){
      settled=true; clearTimeout(watchdog);
      body.innerHTML=sec.outerHTML;
      body.scrollTop=0;
      stripBelowShipping(body);
      reorderTopSection(body);
      execInjectedScripts(body);
      enhancePiuScroll(body);
      wireLightbox(body);
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
      if(window.Shopify&&window.Shopify.PaymentButton){try{window.Shopify.PaymentButton.init();}catch(e){}}
    }
    function showFailed(){
      settled=true; clearTimeout(watchdog);
      body.innerHTML='<div class="upk-qv-loading">Sorry, could not load this product.</div>';
    }

    function themeIdParam(){
      try{
        if(window.Shopify && window.Shopify.theme && window.Shopify.theme.id){
          return '&preview_theme_id='+encodeURIComponent(window.Shopify.theme.id);
        }
      }catch(e){}
      var pt=new URLSearchParams(window.location.search).get('preview_theme_id');
      return pt ? '&preview_theme_id='+encodeURIComponent(pt) : '';
    }

    function fullPageFallback(){
      return fetchWithTimeout(url,{headers:{'Accept':'text/html'}})
        .then(function(r2){ return r2.text(); })
        .then(function(text2){
          var sec2=loadFromDoc(text2);
          if(sec2){ render(sec2); } else { showFailed(); }
        })
        .catch(showFailed);
    }

    fetchWithTimeout(url+'?section_id=main'+themeIdParam(),{headers:{'Accept':'text/html'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.text(); })
      .then(function(text){
        var sec=loadFromDoc(text);
        if(sec){ render(sec); return; }
        return fullPageFallback();
      })
      .catch(fullPageFallback);
  }

  /* Exposed so other card systems on the site (upk-rails.js: Recently
     Viewed / You May Also Like) can trigger the SAME Quick View drawer
     instead of maintaining their own popup. */
  window.upkOpenQuickView = openQuickView;

  function bumpBubble(){
    try{fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var b=document.querySelector('#cart-icon-bubble');
      if(!b)return;
      var spans=b.querySelectorAll('.cart-count-bubble span');
      if(spans.length){spans.forEach(function(s){if(s.getAttribute('aria-hidden')==='true'||!s.className)s.textContent=c.item_count;});}
    });}catch(e){}
  }

  /* Card-level ₹0 guard, the product-card markup carries no raw numeric
     price attribute, only the formatted text inside .pc-price (e.g.
     "₹999" or, for an on-sale item, that plus a struck-through compare
     price). Strip the compare-at <s> first, then strip everything but
     digits; an empty result means the price genuinely parsed to zero.
     Checked BEFORE addToCart() is ever called, so a ₹0 product can never
     reach /cart/add.js from a card's quick-add button. */
  function cardPriceIsZero(card){
    if(!card) return false;
    var priceEl=card.querySelector('.pc-price');
    if(!priceEl) return false;
    var clone=priceEl.cloneNode(true);
    var s=clone.querySelector('s'); if(s) s.remove();
    var digits=String(clone.textContent||'').replace(/[^0-9]/g,'');
    return digits!=='' && parseInt(digits,10)===0;
  }

  /* Renders the cart drawer in place after a card quick-add and opens it.
     Previously this path only bumped the header count: it never asked for
     the drawer sections, never rendered them and never opened the drawer.
     The site-wide fetch patch in up-cart-drawer.js then tries to refresh
     <cart-drawer-items>, but Dawn's EMPTY-cart drawer has no such element,
     so the very first item added to an empty cart never showed up in the
     side cart until the page was refreshed. Rendering the sections returned
     by /cart/add.js (same pattern as the Charm Bar, Watch Bar and PDP Add
     to Bag) fixes that; if there is no drawer on the page we keep the old
     count-only behaviour. */
  // Dawn's own CartDrawer.renderContents() (assets/cart-drawer.js) already
  // calls this.open() itself, on its own setTimeout - so forcing the
  // animate/active classes here too, plus a 500ms drawer.open() fallback,
  // raced Dawn's own transitionend-based focus trap against our other
  // refresh triggers' DOM swaps, producing an intermittent "Cannot read
  // properties of null (reading 'querySelectorAll')" in Dawn's own
  // getFocusableElements. Calling renderContents() and letting Dawn's own
  // open() run once, un-raced, removes that race - the drawer still opens
  // exactly the same, one call instead of two.
  function renderCartDrawer(res){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer||!res||!res.sections||!res.sections['cart-drawer']||typeof drawer.renderContents!=='function'){ bumpBubble(); return; }
    try{ drawer.renderContents(res); }catch(e){ bumpBubble(); return; }
  }

  function addToCart(btn,vid,qty){
    if(!btn||!vid||btn.disabled)return;
    var old=btn.textContent; btn.disabled=true; btn.textContent='Adding\u2026';
    fetchWithTimeout('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:qty}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})})
     .then(function(r){return r.json();})
     .then(function(d){
        if(d&&d.status){btn.textContent='Unavailable';setTimeout(function(){btn.disabled=false;btn.textContent=old;},1500);return;}
        renderCartDrawer(d);
        btn.textContent='\u2713 Added to Bag';
        setTimeout(function(){btn.disabled=false;btn.textContent=old;},1600);
     })
     .catch(function(){btn.disabled=false;btn.textContent=old;});
  }

  document.addEventListener('click',function(e){
    var sw=e.target.closest('[data-pc-sw]');
    if(sw){e.preventDefault();e.stopPropagation();var swc=sw.closest('.pc-card-wrapper');var im=swc&&swc.querySelector('.pc-i1');var im2=swc&&swc.querySelector('.pc-i2');var src=sw.getAttribute('data-pc-sw-img');
      /* Swatch to image (restore list 9): swap the main image AND the hover image, else the second photo covers the swap while the card is hovered or tapped. */
      if(im&&src){im.removeAttribute('srcset');im.src=src;}
      if(im2&&src){im2.removeAttribute('srcset');im2.src=src;}
      var swVid=sw.getAttribute('data-pc-sw-vid');if(swc&&swVid){swc.setAttribute('data-pc-vid',swVid);var u=swc.getAttribute('data-pc-url')||'';if(u){swc.setAttribute('data-pc-url',u.split('?')[0]+'?variant='+swVid);}}
      if(swc){swc.querySelectorAll('[data-pc-sw]').forEach(function(d){d.classList.remove('sel');});}sw.classList.add('sel');return;}
    var w=e.target.closest('[data-pc-wish]');
    if(w){e.preventDefault();w.classList.toggle('liked');w.innerHTML=w.classList.contains('liked')?'&#9829;':'&#9825;';return;}
    var c=e.target.closest('[data-pc-cart]');
    if(c){e.preventDefault();var cw=c.closest('.pc-card-wrapper');openQuickView(cw&&cw.getAttribute('data-pc-url'));return;}
    var a=e.target.closest('[data-pc-atc]');
    if(a){e.preventDefault();var card=a.closest('.pc-card-wrapper');
      var avail=card&&card.getAttribute('data-pc-available')==='true';
      var hasOptions=card&&card.getAttribute('data-pc-options')==='true';
      if(!avail||hasOptions){openQuickView(card&&card.getAttribute('data-pc-url'));}
      else if(cardPriceIsZero(card)){
        var origTxt=a.textContent;
        a.disabled=true; a.textContent='Unavailable';
        setTimeout(function(){ a.disabled=false; a.textContent=origTxt; },1500);
      }
      else{addToCart(a,card.getAttribute('data-pc-vid'),1);}
      return;}
  });
})();
